import { Link } from 'react-router-dom';
import { btnPrimary } from '../../ui/styles';
import { useCheckout } from './useCheckout';
import { CheckoutForm } from './CheckoutForm';
import { OrderSummary } from './OrderSummary';
import { OrderPlaced } from './OrderPlaced';
import { CartAdjustedNotice } from '../cart/CartAdjustedNotice';

/** Afrekenen: formulier met samenvatting, daarna de bedankpagina. */
export function Checkout() {
  const c = useCheckout();
  if (c.placed) return <OrderPlaced placed={c.placed} headingRef={c.doneRef} data-id="element-6945" data-mp="27xd2k6p3pk38" />;
  if (c.cart.lines.length === 0) {
    return <section className="mx-auto max-w-content px-6 py-32 text-center lg:px-10" data-id="element-6946" data-mp="2cwg6tox9bma5">
        <CartAdjustedNotice className="mx-auto mb-10 max-w-lg text-left" data-id="element-6947" data-mp="2guvpxhq7waia" />
        <h1 className="font-display text-4xl font-light text-ink" data-id="element-6948" data-mp="2lw2xbfog77of">Je winkelmand is leeg</h1>
        <p className="mt-4 text-[16px] text-muted" data-id="element-6949" data-mp="3sac00h7cm47w">Voeg eerst iets toe om af te rekenen.</p>
        <Link to="/webshop" className={`${btnPrimary} mt-8`} data-id="element-6950" data-mp="149hash8d0z5">
          Naar de webshop
        </Link>
      </section>;
  }
  return <section className="bg-sand" data-id="element-6951" data-mp="1znr70l7wdfjc">
      <div className="mx-auto grid max-w-content gap-12 px-6 pb-24 pt-8 lg:grid-cols-12 lg:gap-16 lg:px-10 lg:pt-12" data-id="element-6952" data-mp="1uppfdbweo7w9">
        <CartAdjustedNotice className="lg:col-span-12" data-id="element-6953" data-mp="1ppjvihwdnpoq" />
        <CheckoutForm c={c} data-id="element-6954" data-mp="1ps61id3mdx4u" />
        <OrderSummary c={c} data-id="element-6955" data-mp="1krrrwqmdef4p" />
      </div>
    </section>;
}